import { useBrandAndTheme } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { ProductHeroDecor as ProductHeroDecorBettyCrocker } from './ProductHeroDecor.brand.bettycrocker';
import { ProductHeroDecor as ProductHeroDecorPillsbury } from './ProductHeroDecor.brand.pillsbury';
import { ProductHeroDecor as ProductHeroDecorDefault } from './ProductHeroDecor.brand.default';
import { ProductHeroDecor as ProductHeroDecorWhiteLabel } from './ProductHeroDecor.brand.whitelabel';

export const ProductHeroDecor = () => {
  const { brand } = useBrandAndTheme();

  switch (brand) {
    case 'BrandsBettyCrocker':
      return <ProductHeroDecorBettyCrocker />;
    case 'BrandsPillsbury':
      return <ProductHeroDecorPillsbury />;
    case 'BrandsWhiteLabel':
      return <ProductHeroDecorWhiteLabel />;
    default:
      return <ProductHeroDecorDefault />;
  }
};
